import React from 'react';
import { Quarter } from '../types';
import { formatCurrency, getCurrencySymbol, formatNumber } from '../utils/currency';

interface QuarterlyDashboardProps {
  quarters: Quarter[];
}

const QuarterlyDashboard: React.FC<QuarterlyDashboardProps> = ({ quarters }) => {
  return (
    <div className="row mb-2">
      {quarters.map((quarter, index) => (
        <div key={index} className="col-md-6">
          <div className="mt-4">
            <div className="card">
              <div className="card-body">
                <h4>{quarter.title}</h4>
                <table className="table">
                  <thead>
                    <tr>
                      <th className="text-start">Currency</th>
                      <th className="text-start">Unpaid</th>
                      <th className="text-start">Paid</th>
                      <th className="text-start">Expenses</th>
                    </tr>
                  </thead>
                  <tbody>
                    {quarter.sums.map((sum, sumIndex) => (
                      <tr key={sumIndex}>
                        <td>{sum.currency}</td>
                        <td className="text-danger">
                          {sum.sumUnpaid > 0 && (
                            <>
                              {getCurrencySymbol(sum.currency)}{formatNumber(sum.sumUnpaid)}
                              <br />
                              <span style={{ fontSize: '70%', color: 'gray' }}>
                                {formatCurrency(sum.sumUnpaidUsd, 'USD')}
                              </span>
                            </>
                          )}
                        </td>
                        <td className="text-success">
                          {getCurrencySymbol(sum.currency)}{formatNumber(sum.sumPaid)}
                          <br />
                          <span style={{ fontSize: '70%', color: 'gray' }}>
                            {formatCurrency(sum.sumPaidUsd, 'USD')}
                          </span>
                        </td>
                        <td className="text-danger">
                          {getCurrencySymbol(sum.currency)}{formatNumber(sum.sumExpenses)}
                          <br />
                          <span style={{ fontSize: '70%', color: 'gray' }}>
                            {formatCurrency(sum.sumExpensesUsd, 'USD')}
                          </span>
                        </td>
                      </tr>
                    ))}
                    <tr>
                      <td>
                        <strong>
                          Total: {formatCurrency(
                            quarter.sums.reduce((acc, sum) => acc + sum.sumPaidUsd, 0) +
                            quarter.sums.reduce((acc, sum) => acc + sum.sumExpensesUsd, 0) +
                            quarter.sums.reduce((acc, sum) => acc + sum.sumUnpaidUsd, 0),
                            'USD'
                          )}
                        </strong>
                      </td>
                      <td>{formatCurrency(quarter.sums.reduce((acc, sum) => acc + sum.sumUnpaidUsd, 0), 'USD')}</td>
                      <td className="text-success">
                        {formatCurrency(quarter.sums.reduce((acc, sum) => acc + sum.sumPaidUsd, 0), 'USD')}
                      </td>
                      <td className="text-danger">
                        {formatCurrency(quarter.sums.reduce((acc, sum) => acc + sum.sumExpensesUsd, 0), 'USD')}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default QuarterlyDashboard;
